/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fee: NonNullable<unknown> }} Pricing_Sovereign_DescriptionInputs */

const en_pricing_sovereign_description = /** @type {(inputs: Pricing_Sovereign_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your own domain. ${i?.fee}% platform fees. Unlimited listings. Full BYOS.`)
};

const es_pricing_sovereign_description = /** @type {(inputs: Pricing_Sovereign_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu propio dominio. ${i?.fee}% de comisiones de plataforma. Anuncios ilimitados. Trae tu propio Stripe.`)
};

const fr_pricing_sovereign_description = /** @type {(inputs: Pricing_Sovereign_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Votre propre domaine. ${i?.fee} % de frais de plateforme. Annonces illimitées. Apportez votre propre Stripe.`)
};

const de_pricing_sovereign_description = /** @type {(inputs: Pricing_Sovereign_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Deine eigene Domain. ${i?.fee}% Plattformgebühren. Unbegrenzte Inserate. Bring Your Own Stripe.`)
};

const ja_pricing_sovereign_description = /** @type {(inputs: Pricing_Sovereign_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`独自ドメイン。プラットフォーム手数料${i?.fee}%。出品数無制限。BYOS (ご自身のStripeを利用) 対応。`)
};

const zh_pricing_sovereign_description = /** @type {(inputs: Pricing_Sovereign_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`自定义域名。${i?.fee}% 平台费。无限制商品。支持 BYOS (自带 Stripe)。`)
};

const ar_pricing_sovereign_description = /** @type {(inputs: Pricing_Sovereign_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`نطاقك الخاص. رسوم منصة ${i?.fee}%. إعلانات غير محدودة. اربط حساب Stripe الخاص بك.`)
};

const id_pricing_sovereign_description = /** @type {(inputs: Pricing_Sovereign_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Domain Anda sendiri. Biaya platform ${i?.fee}%. Listing tak terbatas. BYOS penuh.`)
};

const it_pricing_sovereign_description = /** @type {(inputs: Pricing_Sovereign_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il tuo dominio. Commissioni di piattaforma ${i?.fee}%. Annunci illimitati. Collega il tuo Stripe.`)
};

const ru_pricing_sovereign_description = /** @type {(inputs: Pricing_Sovereign_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ваш собственный домен. Комиссия платформы ${i?.fee}%. Неограниченное число объявлений. Поддержка BYOS (свой Stripe).`)
};

const pt_pricing_sovereign_description = /** @type {(inputs: Pricing_Sovereign_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seu próprio domínio. ${i?.fee}% de taxa de plataforma. Anúncios ilimitados. Traga seu próprio Stripe.`)
};

const ko_pricing_sovereign_description = /** @type {(inputs: Pricing_Sovereign_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`맞춤형 도메인. 플랫폼 수수료 ${i?.fee}%. 무제한 상품 등록. 자체 Stripe 연결(BYOS).`)
};

/**
* | output |
* | --- |
* | "Your own domain. {fee}% platform fees. Unlimited listings. Full BYOS." |
*
* @param {Pricing_Sovereign_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pricing_sovereign_description = /** @type {((inputs: Pricing_Sovereign_DescriptionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Sovereign_DescriptionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_sovereign_description(inputs)
	if (locale === "es") return es_pricing_sovereign_description(inputs)
	if (locale === "fr") return fr_pricing_sovereign_description(inputs)
	if (locale === "de") return de_pricing_sovereign_description(inputs)
	if (locale === "ja") return ja_pricing_sovereign_description(inputs)
	if (locale === "zh") return zh_pricing_sovereign_description(inputs)
	if (locale === "ar") return ar_pricing_sovereign_description(inputs)
	if (locale === "id") return id_pricing_sovereign_description(inputs)
	if (locale === "it") return it_pricing_sovereign_description(inputs)
	if (locale === "ru") return ru_pricing_sovereign_description(inputs)
	if (locale === "pt") return pt_pricing_sovereign_description(inputs)
	return ko_pricing_sovereign_description(inputs)
});